import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
const BryxDialog = styled((props) => {
    return (_jsxs(Dialog, { ...props, children: [_jsx(DialogTitle, { children: props.title }), _jsx(DialogContent, { children: props.content }), _jsx(DialogActions, { children: props.actions })] }));
})(({ theme: _ }) => {
    // theme stub-- currently a no-op but left in place in the even that future styling is required
    return {
        "& *": {
            fontFamily: "Open Sans",
        },
    };
});
export default BryxDialog;
